import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../ui/table";
import { StatusBadge } from "./status-badge";
import { Card } from "../../ui/card";
import { Badge } from "../../ui/badge";

interface Order {
  productName: string;
  customerName: string;
  orderDate: string;
  totalAmount: number;
  status: "scheduled" | "completed" | "declined";
}

export function RecentOrders() {
  const orders: Order[] = [
    {
      productName: "Velvet Kiss Lipstick",
      customerName: "Yinka Olatunji",
      orderDate: "17 Dec 2024",
      totalAmount: 32.0,
      status: "scheduled",
    },
    {
      productName: "GlowGuard Setting Spray",
      customerName: "Sarah White",
      orderDate: "17 Dec 2024",
      totalAmount: 12.0,
      status: "completed",
    },
    // Add more orders...
  ];

  return (
    <Card>
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-semibold">Recent Orders</h2>

          <div className="flex items-center space-x-2 bg-[#FBEFEF] rounded-md">
            <Badge
              variant="secondary"
              className="bg-[#B87775] text-white px-6 py-2 rounded-none rounded-tl-md rounded-bl-md cursor-pointer "
            >
              Day
            </Badge>
            <Badge
              variant="outline"
              className="px-4 py-2 rounded-none border-none cursor-pointer text-[#B87775]"
            >
              Week
            </Badge>
            <Badge
              variant="outline"
              className="px-4 py-2 rounded-none border-none cursor-pointer text-[#B87775]"
            >
              Month
            </Badge>
            <Badge
              variant="outline"
              className="px-4 py-2 rounded-none border-none cursor-pointer text-[#B87775]"
            >
              Year
            </Badge>
          </div>
        </div>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Product Name</TableHead>
              <TableHead>Customer Name</TableHead>
              <TableHead>Order Date</TableHead>
              <TableHead>Total Amount</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {orders.map((order, index) => (
              <TableRow key={index}>
                <TableCell>{order.productName}</TableCell>
                <TableCell>{order.customerName}</TableCell>
                <TableCell>{order.orderDate}</TableCell>
                <TableCell>${order.totalAmount.toFixed(2)}</TableCell>
                <TableCell>
                  <StatusBadge status={order.status} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}
